import { useDistrict } from "../lib/district-context";

export function useDistrictGuard() {
  const { district, loading, userProfile, coordinatorChurchId } = useDistrict();
  const districtId = district?.id ?? null;
  const ready = !loading && !!districtId;
  return { district, districtId, ready, loading, userProfile, coordinatorChurchId };
}
